module.exports = __webpack_public_path__ + "img/services-flow.99539bbd.png";